<script>
import WorkScheduleContainer from '@/components/schedule/work-schedule-container.vue'
import Layout from '@/router/layouts/main.vue'

export default {
  name: 'WorkSchedule',

  components: {
    WorkScheduleContainer,
    Layout,
  },

  props: {
    clientId: {
      type: String,
      required: true,
    },
    locationIds: {
      type: String,
      default: () => '',
    },
  },

  computed: {
    parsedProps() {
      return {
        clientId: parseInt(this.clientId) || -1,
        locationIds: this.locationIds?.length
          ? this.locationIds
              .split(',')
              .map(Number)
              .filter((id) => !isNaN(id))
          : [],
      }
    },
  },
}
</script>

<template>
  <Layout>
    <WorkScheduleContainer v-bind="parsedProps" />
  </Layout>
</template>
